import { render, staticRenderFns } from "./askQuestion.vue?vue&type=template&id=37803c84&scoped=true&"
import script from "./askQuestion.vue?vue&type=script&lang=js&"
export * from "./askQuestion.vue?vue&type=script&lang=js&"
import style0 from "./askQuestion.vue?vue&type=style&index=0&id=37803c84&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37803c84",
  null
  
)

export default component.exports